// Автоформат при наборе (как в Word, но только в рамках СТО): в начале пустого абзаца
//   «# » / «## » / «### »  -> раздел / подраздел / пункт
//   «- » или «– »          -> перечисление с дефисом
//   «а) »                   -> перечисление с буквами,  «1) » -> с цифрами
// Сразу после автозамены Backspace возвращает набранные знаки (undoInputRule).
import { Extension, InputRule } from '@tiptap/core';
import { findWrapping } from '@tiptap/pm/transform';

function inTopParagraph(state: any, start: number): boolean {
  const $s = state.doc.resolve(start);
  if ($s.parent.type.name !== 'paragraph') return false;
  const up = $s.depth >= 2 ? $s.node($s.depth - 1).type.name : 'doc';
  return up === 'doc' || up === 'appendix';
}

export const AutoformatExtension = Extension.create({
  name: 'stoAutoformat',
  addInputRules() {
    const schema = this.editor.schema;
    const rules: InputRule[] = [];
    rules.push(new InputRule({
      find: /^(#{1,3})\s$/,
      handler: ({ state, range, match }) => {
        if (!inTopParagraph(state, range.from)) return null;
        state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, schema.nodes.heading, { level: match[1].length });
        return undefined;
      },
    }));
    const list = (re: RegExp, kind: string) => new InputRule({
      find: re,
      handler: ({ state, range }) => {
        if (!inTopParagraph(state, range.from) || !schema.nodes.stoList) return null;
        const tr = state.tr.delete(range.from, range.to);
        const $s = tr.doc.resolve(range.from);
        const r = $s.blockRange();
        const wrap = r && findWrapping(r, schema.nodes.stoList, { kind });
        if (!r || !wrap) return null;
        tr.wrap(r, wrap);
        return undefined;
      },
    });
    rules.push(list(/^\s*[-–—*]\s$/, 'dash'));
    rules.push(list(/^\s*[аa]\)\s$/, 'letter'));
    // «1) » в начале абзаца верхнего уровня - «а)» (4.4.4: цифры - только во вложенном перечислении)
    rules.push(list(/^\s*1\)\s$/, 'letter'));
    return rules;
  },
});
